import { ParticipanteFila } from "../../../Participantes/Models";
import { Button, ButtonGroup } from "react-bootstrap";
import ReactTooltip from 'react-tooltip';
import { useState } from "react";
import { conEvento } from "../../Models/Coneccion";
import FormParticipante from "../../../Participantes/Editar";
import { ListButonClick } from "../../../../../Components/Button/ListBoton";
import { getEvento, update } from "../index";
import RegistrarPago from "../../../Pagos/Nuevo";
import { toast } from "react-toastify";
interface Props {
    data: ParticipanteFila
}
export default function Fila({ data }: Props) {
    const evento = getEvento();
    const { nombre, correo, telefono, id } = data;
    const [edit, setEdit] = useState(false);
    const [pago, setPago] = useState(false);
    return <tr className="info" >
        <td>{nombre}</td>
        <td>{correo}</td>
        <td>{telefono}</td>
        <td className="text-right">
            <ReactTooltip key={`data${Math.random()}`} />
            <RegistrarPago participante={data} open={pago} close={() => { setPago(false); }} />
            {edit ? <FormParticipante open={edit} title={`EDITAR ${nombre}`} participante={data} close={() => setEdit(false)} add={() => { }} /> : <></>}
            <ButtonGroup>
                <ListButonClick permiso='PAR_CREAR' tip="EDITAR" variant="primary" click={() => setEdit(true)}>
                    <i className="fa fa-edit" />
                </ListButonClick>
                <Button onClick={() => setPago(true)} data-tip='REGISTAR NUEVO PAGO' variant="dark">
                    <i className="fas fa-usd-square" />
                </Button>
                {evento.estatus === 1 ? <>
                    <Button variant="info" data-tip='PREINSCRIBIR EN EL EVENTO'
                        onClick={() => conEvento().preinscribir(evento.id, id, () => {
                            update();
                            toast('PARTICIPANTE PREINSCRITO', { type: toast.TYPE.SUCCESS });
                        })}>
                        <i className="fa fa-check" />
                    </Button>
                    <Button variant="success" data-tip='INSCRIBIR EN EL EVENTO'
                        onClick={() => conEvento().inscribir(evento.id, id, () => {
                            update();
                            toast('PARTICIPANTE INSCRITO', { type: toast.TYPE.SUCCESS });
                        })}>
                        <i className="fa fa-check-double" />
                    </Button>
                </> : <></>}
            </ButtonGroup>
        </td>
    </tr>
}